import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { BalanceDriftSection } from '@/features/ledger/drift-alerts'

/**
 * The balance drift register, as an addressable screen of its own.
 *
 * A queue with a deadline at the end of every trading day rather than a monitoring screen: an
 * unresolved alarm stops the branch closing. The disposition is a dialog with a mandatory reason —
 * repaired, or accepted with an explanation — because on the second of those the reason is the whole
 * of the control.
 */
export function LedgerBalanceDriftPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Balance drift"
        description="Stored balances that do not follow from their postings. An unresolved alarm means a reported figure may be wrong, and it blocks the branch's day close until somebody disposes of it."
      />

      <BalanceDriftSection />
    </>
  )
}
